module.exports = __webpack_public_path__ + "pc-top-assets/img/twitter.dbe9b4ac.png";